import React, {useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import Container from 'components/layout/Container';
import Calculator from 'components/blocks/Caclulator';
import Suggestions from 'components/blocks/Suggestions';
import Continue from 'components/blocks/Continue';
import {TARIFFS} from 'data/tariffs';
import {TARIFF_SERVICES} from 'data/tariffServices';
import TariffOrderSection from 'components/blocks/TariffOrderSection';
import {useInView} from 'react-intersection-observer';
import AreaInput from 'components/blocks/AreaInput';
import formatNumber from 'utils/formatNumber';
import useAnalyticEvent from 'hooks/useAnalyticsEveent';

import './TariffPage.scss';

function TariffPage() {
  useAnalyticEvent('quick_view', {});
  const {slug} = useParams();
  const tariff = TARIFFS[slug];
  const tariffServices = TARIFF_SERVICES.filter(tableEntry => tableEntry[slug]);
  const isCustomTariff = slug === 'custom';
  const [tariffOrderSectionRef, isTariffOrderSectionVisible] = useInView({
    threshold: 0.3,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!tariff) {
    return null;
  }

  return (
    <main className="tariff-page">
      <Container>
        <div className="tariff-page__info">
          <div className="tariff-page__info_left">
            <Title
              extraClassName="tariff-page__title"
              level={TitleLevel.H2}
              size={TitleSize.H3}
              color={TitleColor.black}
            >
              <span className="tariff-page__name--superscript">Тариф</span>
              {!isCustomTariff && (
                <span className="tariff-page__price--superscript">
                  Расчёт м<sup>2</sup>&nbsp;по&nbsp;полу
                </span>
              )}
              <span className="tariff-page__name">{tariff.name} ремонт</span>
              {tariff.price > 0 && (
                <span className="tariff-page__price">
                  {formatNumber(tariff.price)}&nbsp;₽&nbsp;/ м&sup2;
                </span>
              )}
            </Title>

            <p className="tariff-page__description">{tariff.description}</p>

            {!isCustomTariff && (
              <>
                <span className="tariff-page__service-list-title">
                  Прокетные работы
                </span>
                <ul className="tariff-page__service-list">
                  {tariffServices
                    .filter(tariffService => tariffService.type === 'PROJECT')
                    .map((tariffService, index) => (
                      <li className="tariff-page__service" key={index}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle cx="12" cy="12" r="12" fill="white" />
                          <path
                            d="M6 12L10 16L18 8"
                            stroke="#0000FF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {tariffService.name}
                      </li>
                    ))}
                </ul>
              </>
            )}

            {!isCustomTariff && (
              <>
                <span className="tariff-page__service-list-title">
                  Ремонтные работы
                </span>
                <ul className="tariff-page__service-list">
                  {tariffServices
                    .filter(tariffService => tariffService.type === 'REMONT')
                    .map((tariffService, index) => (
                      <li className="tariff-page__service" key={index}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle cx="12" cy="12" r="12" fill="white" />
                          <path
                            d="M6 12L10 16L18 8"
                            stroke="#0000FF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {tariffService.name}
                      </li>
                    ))}
                </ul>

                <div className="tariff-page__warning">
                  <p className="tariff-page__warning-text">
                    Если после завершения проектных работ вы&nbsp;решите
                    заказать ремонт в&nbsp;другом месте, мы&nbsp;попросим вас
                    их&nbsp;оплатить:
                  </p>

                  <p className="tariff-page__warning-price">
                    12&nbsp;500&nbsp;₽
                  </p>

                  <p className="tariff-page__warning-caption">
                    Стоимость проектных работ в&nbsp;случае отказа
                    от&nbsp;ремонта фиксирована и&nbsp;не&nbsp;зависит
                    от&nbsp;площади помещения
                  </p>
                </div>

                {!isCustomTariff && <AreaInput />}
              </>
            )}
          </div>

          {!isCustomTariff && (
            <div className="tariff-page__info_right">
              <div className="tariff-page__info-price">
                <span className="tariff-page__price">
                  {formatNumber(tariff.price)}&nbsp;₽&nbsp;/ м&sup2;
                </span>
                {!isCustomTariff && (
                  <span className="tariff-page__price--superscript">
                    Расчёт м²&nbsp;по&nbsp;полу
                  </span>
                )}
              </div>

              <Link
                className="button tariff-comparison__button"
                to="/tariff-comparison"
              >
                Сравнить тарифы
              </Link>

              <div className="tariff-page__warning">
                <p className="tariff-page__warning-text">
                  Если после завершения проека вы&nbsp;решите заказать ремонт
                  в&nbsp;другом месте, мы&nbsp;попросим вас оплатить выполненную
                  часть работ:
                </p>

                <p className="tariff-page__warning-price">12&nbsp;500&nbsp;₽</p>

                <p className="tariff-page__warning-caption">
                  Стоимость фиксирована и&nbsp;не&nbsp;зависит от&nbsp;площади
                  помещения.
                </p>
              </div>
            </div>
          )}
        </div>
      </Container>

      {!isCustomTariff && <Suggestions />}

      {isCustomTariff && <Calculator />}

      <TariffOrderSection innerRef={tariffOrderSectionRef} slug={slug} />

      {!isTariffOrderSectionVisible && <Continue />}
    </main>
  );
}

export default TariffPage;
